import React, { FC } from 'react';
import { DiffEditor } from '@monaco-editor/react';

interface ActivityLogDiffViewProps {
    original: string;
    modified: string;
}

const ActivityLogDiffView: FC<ActivityLogDiffViewProps> = ({
    original,
    modified,
}) => (
    <DiffEditor
        height="100%"
        language="json"
        original={original}
        modified={modified}
        options={{
            readOnly: true,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            renderSideBySide: false,
        }}
    />
);

export default ActivityLogDiffView;
